import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useRef, useState, useEffect } from 'react';
import { List, ListItem, CheckIcon } from './style.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { UI_CHECKMARK } from '../../icons/UI_CHECKMARK.js';

var ValuePropositions = function ValuePropositions(_ref) {
  var items = _ref.items,
    _ref$animate = _ref.animate,
    animate = _ref$animate === void 0 ? true : _ref$animate,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? null : _ref$className;
  var wrapRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    intersected = _useState2[0],
    setIntersected = _useState2[1];

  // Observe wrapper element and update intersected state when element is visible in viewport
  // If intersected, css class is applied that triggers transition of list items
  useEffect(function () {
    var handleIntersection = function handleIntersection(entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          setIntersected(true);
        }
      });
    };
    var observer = new IntersectionObserver(handleIntersection);
    var element = wrapRef.current;
    if (element && animate) {
      observer.observe(element);
      return function () {
        return observer.unobserve(element);
      };
    }
    return undefined;
  });
  if (!items) {
    return null;
  }
  return /*#__PURE__*/jsx(List, {
    ref: wrapRef,
    className: className,
    children: items.map(function (item, index) {
      return /*#__PURE__*/jsxs(ListItem, {
        animate: animate,
        intersected: intersected
        // eslint-disable-next-line react/no-array-index-key
        ,
        children: [/*#__PURE__*/jsx(CheckIcon, {
          path: UI_CHECKMARK,
          size: "xs",
          sizeMobile: "xs"
        }), item]
      }, "".concat(item).concat(index));
    })
  });
};
var ValuePropositions$1 = ValuePropositions;

export { ValuePropositions$1 as default };
//# sourceMappingURL=ValuePropositions.js.map
